import { render, staticRenderFns } from "./TransactionHistory.vue?vue&type=template&id=88f40f76"
import script from "./TransactionHistory.vue?vue&type=script&lang=js"
export * from "./TransactionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports